import { inject, Injectable } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ActivatedRouteSnapshot } from "@angular/router";
import { describeModalOpened } from "src/app/shared/helpers/support-event-descriptions.helper";
import { OnboardingModalComponent } from "./onboarding-modal.component";
import {
  OnboardingModalData,
  OnboardingModalService,
  OnboardingMomentStep,
} from "./onboarding-modal.service";

/** Moments shown in the wide, short dialog; the rest are longer and use `46rem`. */
const COMPACT_MOMENTS: ReadonlySet<OnboardingMomentStep> = new Set([
  "welcomeFirstTimeOnboarding",
  "resumeIncompleteStoreSetup",
  "afterLinkingStore",
]);

/**
 * Opens the onboarding modal. Every view that shows it goes through here, so the
 * dialog looks the same everywhere and each opening is recorded for support.
 */
@Injectable({
  providedIn: "root",
})
export class OnboardingFlowService {
  private readonly dialog = inject(MatDialog);
  private readonly onboardingModalService = inject(OnboardingModalService);

  openMoment(
    momentStep: OnboardingMomentStep,
    route?: ActivatedRouteSnapshot,
  ): MatDialogRef<OnboardingModalComponent, boolean> {
    this.onboardingModalService.recordSupportHistory(
      route,
      "modal_opened",
      describeModalOpened("onboarding dialog", { momentStep }),
    );

    const data: OnboardingModalData = { momentStep, parentRoute: route };
    return this.dialog.open(OnboardingModalComponent, {
      data,
      width: "auto",
      maxWidth: COMPACT_MOMENTS.has(momentStep) ? "90vw" : "46rem",
      panelClass: "onboarding-dialog-panel",
      disableClose: true,
    });
  }
}
